<template>
  <div class="bullet" style>
    <div class="bullet_main">
      <a class="close" href="javascript:;" @click="close">×</a>
      <div>
        <input
          name="keyword"
          v-model="keyword"
          class="search_keyword"
          type="text"
          value
          placeholder="搜索文物名称"
        />
      </div>
      <div class="search_row">
        <select name="status" class="search_status" v-model="status">
          <option :value="status.id" :key="status.id" v-for="status in statusList">{{status.name}}</option>
        </select>
      </div>
      <div class="search_row">
        <a href="javascript:;" @click="search">搜索</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      show: false,
      // 文物状态
      statusList: [
        {
          id: "0",
          name: "选择状态"
        },
        {
          id: "1",
          name: "馆藏"
        },
        {
          id: "2",
          name: "赠人"
        },
        {
          id: "3",
          name: "卖出"
        }
      ],
      status: "0",
      keyword: ""
    };
  },
  methods: {
    // 关闭搜索
    close() {
      this.$emit("closed", this.show);
    },
    search() {
      // 传递搜索内容
      this.$emit("search", this.keyword, this.status);
      // 关闭当前搜索框
      this.$emit("closed", this.show);
    }
  }
};
</script>

<style scoped>
.bullet {
  background-color: rgba(247, 248, 248, 1);
  position: fixed;
  top: 0.1rem;
  right: 0.1rem;
  bottom: 0.1rem;
  left: 0.1rem;
  z-index: 999999;
  padding: 0.1rem;
  box-sizing: border-box;
  overflow: hidden;
}
.bullet_main {
  padding: 0.4rem 0.18rem 0.18rem 0.18rem;
  border: 1px solid #c1925b;
  position: relative;
  height: 100%;
  overflow-y: scroll;
  border-radius: 3px;
}
.bullet_main p {
  font-size: 0.13rem;
  font-weight: normal;
  color: #626262;
  font-family: "思源黑体 CN";
  line-height: 0.22rem;
  margin-top: 0.2rem;
  text-indent: 0em;
}
.close {
  width: 0.21rem;
  height: 0.21rem;
  background-color: #c1925b;
  border-radius: 100px;
  position: absolute;
  top: 0.2rem;
  right: 0.2rem;
  font-size: 0.2rem;
  font-weight: bold;
  color: #fff;
  text-align: center;
  line-height: 0.22rem;
  overflow: hidden;
}

.search_keyword {
  margin-top: 0.2rem;
  width: 100%;
  height: 0.36rem;
  border: 1px solid #dddddd;
  border-radius: 10px;
  padding: 0 0 0 14px;
  box-sizing: border-box;
  font-size: 0.14rem;
  font-weight: normal;
  color: #333333;
  line-height: 0.36rem;
}

.search_row a {
  width: 50%;
  height: 0.35rem;
  font-size: 0.14rem;
  font-weight: bold;
  text-align: center;
  border-radius: 10px;
  background-color: #c1925b;
  line-height: 0.36rem;
  display: block;
  color: #fff;
  margin-top: 0.4rem;
  margin-left: 0.55rem;
}
.search_status {
  width: 100%;
  height: 0.36rem;
  border: 1px solid #dddddd;
  border-radius: 10px;
  padding: 0 0 0 14px;
  box-sizing: border-box;
  font-size: 0.14rem;
  font-weight: normal;
  font-family: "HYQuanTangShiJ";
  /* color: #333333; */
  line-height: 0.36rem;
  margin-top: 0.2rem;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: url("http://ourjs.github.io/static/2015/arrow.png") no-repeat
    scroll right 0.1rem center transparent;
  padding-right: 14px;
  background-color: #fff;
}

.option {
  border-radius: 10px;
  padding: 0 0 0 14px;
  box-sizing: border-box;
  font-size: 1.14rem;
  font-weight: normal;
  color: #333333;
  line-height: 0.36rem;
}
</style>